<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    size?: 'page' | 'button' | 'sm'
    color?: string
  }>(),
  {
    size: 'page',
    color: undefined,
  },
)

const sizeClasses: Record<'page' | 'button' | 'sm', string> = {
  page: 'h-8 w-8',
  button: 'h-4 w-4',
  sm: 'h-3.5 w-3.5',
}

const defaultColorClasses: Record<'page' | 'button' | 'sm', string> = {
  page: 'text-emerald-500',
  button: 'text-white',
  sm: 'text-white',
}

const svgClasses = computed(
  () => `animate-spin ${sizeClasses[props.size]} ${props.color ?? defaultColorClasses[props.size]}`,
)
</script>

<template>
  <div v-if="size === 'page'" class="flex items-center justify-center py-20">
    <svg
      :class="svgClasses"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  </div>
  <svg
    v-else
    :class="svgClasses"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
</template>
